import {format, addQuarters, differenceInMonths} from "date-fns";
import * as React from "react";
import "./styles.scss";
import {
  IProfile,
  IFinanceBasicInfo,
  ILoanInfo,
  SalaryMode,
  EmploymentType,
  IDocument, IUserStatus,
  PurposeType
} from "StateInterface";
import getFileType from "userform/file-type";
import { Flags } from "reducers/flagActions";
import { getYear } from "date-fns";
import {diffDays, diffYears, isMobile, isValidPan, startsWithZero} from "utils";
import * as request from "request";
import {envLam, imageBaseUrl} from "../config";
import classnames from "classnames";

export enum Screens {
  GET_STARTED = "Get Started",
  BASIC_PERSONAL = "Personal",
  RESIDENCE = "Residence",
  EDUCATION = "Education",
  EMPLOYMENT = "Employment",
  DOCUMENTS = "Documents",
  BANK_STATEMENT = "Bank Statement",
  PRODUCT_DETAILS = "PRODUCT_DETAILS",
  NON_SERVICEABLE = "NON_SERVICEABLE",
  REFERENCES = "References",
  LOAN_AMOUNT_TENURE = "Loan Details",
  ASSETS = "Assets"
}

export enum Fields {
  NAME = "NAME",
  BIRTHDAY = "BIRTHDAY",
  AADHAAR_NUMBER = "AADHAAR_NUMBER",
  MOTHERS_NAME = "MOTHERS_NAME",
  FATHERS_NAME = "FATHERS_NAME",
  DOB = "DOB",
  PAN_NUMBER = "PAN_NUMBER",
  MOBILE = "MOBILE",
  ALTERNATE_MOBILE = "ALTERNATE_MOBILE",
  GENDER = "GENDER",
  RELATIONSHIP_STATUS = "RELATIONSHIP_STATUS",
  CURR_ADDRESS_HOUSE = "CURR_ADDRESS_HOUSE",
  CURR_ADDRESS_STREET = "CURR_ADDRESS_STREET",
  CURR_ADDRESS_LOCALITY = "CURR_ADDRESS_LOCALITY",
  CURR_ADDRESS_LANDMARK = "CURR_ADDRESS_LANDMARK",
  CURR_ADDRESS_PINCODE = "CURR_ADDRESS_PINCODE",
  ADDRESS_PINCODE = "ADDRESS_PINCODE",
  RESIDENT_TYPE = "RESIDENT_TYPE",
  STAYING_SINCE = "STAYING_SINCE",
  WORKING_SINCE = "WORKING_SINCE",
  RENT_MONTHLY = "RENT_MONTHLY",
  PERM_ADDRESS_HOUSE = "PERM_ADDRESS_HOUSE",
  PERM_ADDRESS_STREET = "PERM_ADDRESS_STREET",
  PERM_ADDRESS_LOCALITY = "PERM_ADDRESS_LOCALITY",
  PERM_ADDRESS_LANDMARK = "PERM_ADDRESS_LANDMARK",
  PERM_ADDRESS_PINCODE = "PERM_ADDRESS_PINCODE",
  PERM_ADDRESS_SAME_AS_CURR_ADDRESS = "PERM_ADDRESS_SAME_AS_CURR_ADDRESS",
  HIGHEST_EDUCATION = "HIGHEST_EDUCATION",
  WORK_EXPERIENCE_YEARS = "WORK_EXPERIENCE_YEARS",
  WORK_EXPERIENCE_MONTHS = "WORK_EXPERIENCE_MONTHS",
  SELECT_CURRENT_EMPLOYER = "SELECT_CURRENT_EMPLOYER",
  EMPLOYER_TYPE = "EMPLOYER_TYPE",
  EMPLOYEE_ID = "EMPLOYEE_ID",
  CURRENT_EMPLOYER = "CURRENT_EMPLOYER",
  DESIGNATION = "DESIGNATION",
  WORK_EMAIL = "WORK_EMAIL",
  WORK_ADDRESS_HOUSE = "WORK_ADDRESS_HOUSE",
  WORK_ADDRESS_STREET = "WORK_ADDRESS_STREET",
  WORK_ADDRESS_LOCALITY = "WORK_ADDRESS_LOCALITY",
  WORK_ADDRESS_LANDMARK = "WORK_ADDRESS_LANDMARK",
  WORK_ADDRESS_PINCODE = "WORK_ADDRESS_PINCODE",
  NET_MONTHLY_INCOME = "NET_MONTHLY_INCOME",
  CREDIT_LIMIT = "CREDIT_LIMIT",
  TOTAL_DEPENDENTS = "TOTAL_DEPENDENTS",
  ASSET_TWO_WHEELER = "ASSET_TWO_WHEELER",
  ASSET_FOUR_WHEELER = "ASSET_FOUR_WHEELER",
  ASSET_FLAT_APARTMENT_HOUSE = "ASSET_FLAT_APARTMENT_HOUSE",
  ASSET_LAND = "ASSET_LAND",
  ASSET_FIXED_DEPOSIT = "ASSET_FIXED_DEPOSIT",
  ASSET_JEWELLERY = "ASSET_JEWELLERY",
  ASSET_EPF = "ASSET_EPF",
  ASSET_HEALTH_INSURANCE = "ASSET_HEALTH_INSURANCE",
  REFERENCE_NAME_1 = "REFERENCE_NAME_1",
  REFERENCE_MOBILE_1 = "REFERENCE_MOBILE_1",
  REFERENCE_EMAIL_1 = "REFERENCE_EMAIL_1",
  REFERENCE_RELATION_1 = "REFERENCE_RELATION_1",
  REFERENCE_NAME_2 = "REFERENCE_NAME_2",
  REFERENCE_MOBILE_2 = "REFERENCE_MOBILE_2",
  REFERENCE_EMAIL_2 = "REFERENCE_EMAIL_2",
  REFERENCE_RELATION_2 = "REFERENCE_RELATION_2",
  BS_UPLOAD = "BS_UPLOAD",
  SALARY_MODE = "SALARY_MODE",
  LIVING_WITH = "LIVING_WITH",
  RESIDENT_TYPE_PERM = "RESIDEN_TYPE_PERM",
  EMPLOYMENT_TYPE = "EMPLOYMENT_TYPE",
  SOURCING_CODE = "SOURCING_CODE",
  DELIVERY_ADDRESS_HOUSE = "DELIVERY_ADDRESS_HOUSE",
  DELIVERY_ADDRESS_STREET = "DELIVERY_ADDRESS_STREET",
  DELIVERY_ADDRESS_LOCALITY = "DELIVERY_ADDRESS_LOCALITY",
  DELIVERY_ADDRESS_LANDMARK = "DELIVERY_ADDRESS_LANDMARK",
  DELIVERY_ADDRESS_PINCODE = "DELIVERY_ADDRESS_PINCODE",
  LOAN_AMOUNT = "LOAN_AMOUNT",
  LOAN_TENURE_MONTHS = "LOAN_TENURE_MONTHS",
  LOAN_PURPOSE = "LOAN_PURPOSE",
  LOAN_PURPOSE_REMARK = "LOAN_PURPOSE_REMARK",
  BUYING_FOR = "BUYING_FOR",
  IS_DELIVERY_ADDR_SAME_AS_CURR_ADDR = "IS_DELIVERY_ADDR_SAME_AS_CURR_ADDR",
  OTP = "OTP",
  CONSENT_DENY_REASON = "CONSENT_DENY_REASON",
  LOAN_OTHER_SOURCE = "LOAN_OTHER_SOURCE",
  CHECQUE_PRESENCE = "CHEQUE_PRESENCE",
  IS_AADHAAR_LINKED_WITH_MOBILE = "IS_AADHAAR_LINKED_WITH_MOBILE",
  APPOINTMENT_LOCATION = "APPOINTMENT_LOCATION",
  APPOINTMENT_DATE = "APPOINTMENT_DATE",
  APPOINTMENT_TIME = "APPOINTMENT_TIME",
  DOCUMENTATION_MODE = "DOCUMENTATION_MODE",
  TOTAL_CURRENT_EMI = "TOTAL_CURRENT_EMI",
  HAS_TOTAL_CURRENT_EMI = "HAS_TOTAL_CURRENT_EMI",
  NOMINEE_NAME = "NOMINEE_NAME",
  NOMINEE_MOBILE = "NOMINEE_MOBILE",
  NOMINEE_DOB = "NOMINEE_DOB",
  NOMINEE_RELATION = "NOMINEE_RELATION",
  BANK_AC_NUMBER = "BANK_AC_NUMBER",
  IFSC_CODE = "IFSC_CODE",
  RE_ENTER_BANK_AC_NUMBER = "RE_ENTER_BANK_AC_NUMBER",
  BANK_NAME = "BANK_NAME",
  BANK_PURPOSE_TYPE = "BANK_PURPOSE_TYPE",
}

export enum DocTypes {
  SELFIE = "SELFIE",
  PAN = "PAN",
  PAY_SLIP_1 = "PAY_SLIP_1",
  AADHAAR = "AADHAAR",
  AADHAAR_FRONT = "AADHAAR_FRONT",
  AADHAAR_BACK = "AADHAAR_BACK",
  CURRENT_ADDRESS_PROOF = "CURRENT_ADDRESS_PROOF",
  RENTAL_AGREEMENT = "RENTAL_AGREEMENT",
  OFFER_LETTER = "OFFER_LETTER",
  OTHER = "OTHER",
  CURR_ADDR_PROOF = "CURR_ADDR_PROOF",
  PAY_SLIP = "PAY_SLIP",
  SIGNED_CHEQUE = "SIGNED_CHEQUE",
  CANCELLED_CHEQUE = "CHEQUE",
  NACH = "NACH",
}

export const allScreens = [
  Screens.GET_STARTED,
  Screens.BASIC_PERSONAL,
  Screens.RESIDENCE,
  Screens.EMPLOYMENT,
  Screens.LOAN_AMOUNT_TENURE,
  Screens.REFERENCES,
  Screens.DOCUMENTS,
  Screens.BANK_STATEMENT,
];

export const v3Screens = [
  Screens.GET_STARTED,
  Screens.BASIC_PERSONAL,
  Screens.RESIDENCE,
  Screens.EMPLOYMENT,
  Screens.LOAN_AMOUNT_TENURE,
  Screens.BANK_STATEMENT,
];

export function getV2Fields(screen) {
  if (screen === Screens.BASIC_PERSONAL) {
    return [Fields.NAME, Fields.DOB, Fields.GENDER, Fields.RELATIONSHIP_STATUS, Fields.HIGHEST_EDUCATION,
      Fields.PAN_NUMBER , Fields.FATHERS_NAME, Fields.MOTHERS_NAME, Fields.TOTAL_DEPENDENTS, Fields.MOBILE];
  }
}

export function getV3Fields(screen) {
  if (screen === Screens.BASIC_PERSONAL) {
    return [Fields.NAME, Fields.DOB, Fields.GENDER, Fields.PAN_NUMBER , Fields.ALTERNATE_MOBILE];
  } else if (screen === Screens.EMPLOYMENT) {
    return [Fields.WORK_EXPERIENCE_YEARS, Fields.WORK_EXPERIENCE_MONTHS, Fields.SELECT_CURRENT_EMPLOYER,
      Fields.EMPLOYER_TYPE, Fields.EMPLOYEE_ID, Fields.DESIGNATION, Fields.WORKING_SINCE];
  } else if (screen === Screens.LOAN_AMOUNT_TENURE) {
    return [Fields.LOAN_AMOUNT, Fields.LOAN_TENURE_MONTHS, Fields.TOTAL_CURRENT_EMI];
  }
}

function isMandatoryDocsComplete(documents, mandatoryDocs) {
  let completedDocs = [];
  completedDocs = documents.filter(
    d => d !== null && mandatoryDocs.indexOf(d.type) !== -1
  );
  return completedDocs.length >= mandatoryDocs.length;
}

function isBankStatementComplete(bankStatement) {
  return (
    bankStatement &&
    (bankStatement.available.length > 0 || bankStatement.pending.length > 0)
  );
}

export function getFlag(screen: Screens) {
  if (screen === Screens.GET_STARTED) {
    return Flags.showGetStarted;
  }
  if (screen === Screens.BASIC_PERSONAL) {
    return Flags.showPersonalInfo;
  }
  if (screen === Screens.RESIDENCE) {
    return Flags.showResidenceInfo;
  }
  if (screen === Screens.EMPLOYMENT) {
    return Flags.showEmploymentInfo;
  }
  if (screen === Screens.DOCUMENTS) {
    return Flags.showDocumentsInfo;
  }
  if (screen === Screens.BANK_STATEMENT) {
    return Flags.showBankStatementInfo;
  }
  if (screen === Screens.LOAN_AMOUNT_TENURE) {
    return Flags.showLoanAmountTenure;
  }
  if (screen === Screens.REFERENCES) {
    return Flags.showReferences;
  }
}
export function validateName(name) {
  const nameRegex = /^[a-zA-Z ]{2,30}$/;
  return nameRegex.test(name);
}
export function validatePhoneNumber(phoneNumber) {
  const numberRegex = /^[5-9]\d{9}$/;
  return numberRegex.test(phoneNumber);
}
export function validateReferencePhNumber(referenceNumber, profile) {
  const listOfExistingProfileNumbers = profile.alternateMobileNumbers
    ? [profile.mobile].concat(profile.alternateMobileNumbers)
    : [profile.mobile];
  if (validatePhoneNumber(referenceNumber)) {
    return !listOfExistingProfileNumbers.includes(referenceNumber);
  } else {
    return false;
  }
}
export function renderNotEligibleScreen() {
  return (
      <div className="row text-center">
        <div className="col-sm-12">
          <br/><br/><br/>
          <img src={`${imageBaseUrl}/img/notEligibleMeter.png`} alt="" style={{width: "80px"}}/><br/>
          <h3>We are extremely sorry!</h3>
          <span>Sorry! You are not eligible for the loan. Please try again later!</span>
        </div>
      </div>
  );
}
export function isEmailValid(email) {
  const emailRegex = /^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4}|museum)$/;
  return emailRegex.test(email);
}
export function validateEmployementFields(profile, sourcingCode, sourcingCodes, displayFields) {
  const validation = {
    status: false,
    type: null,
    msg: null,
    incompleteStatus: true,
  };
  if ((!profile.currentEmployer
        || profile.currentEmployer === "Select Employer"
        || profile.currentEmployer.toUpperCase() === "OTHER")
        && (displayFields ? displayFields.includes(Fields.SELECT_CURRENT_EMPLOYER) : true)) {
        validation.type = Fields.SELECT_CURRENT_EMPLOYER;
        validation.msg = "Mandatory";
    } else if ((!profile.currentEmployer
        || profile.currentEmployer === "Select Employer"
        || profile.currentEmployer.toUpperCase() === "URBANCLAP TECHNOLOGIES INDIA PRIVATE LIMITED"
        && (!sourcingCode || sourcingCodes.indexOf(sourcingCode.toUpperCase()) === -1))
        && (displayFields ? displayFields.includes(Fields.SOURCING_CODE) : true)) {
        validation.type = Fields.SOURCING_CODE;
        validation.msg = "Mandatory";
    } else if ((!profile.employerType || profile.employerType === "Select Company Type")
        && (displayFields ? displayFields.includes(Fields.EMPLOYER_TYPE) : true)) {
        validation.type = Fields.EMPLOYER_TYPE;
        validation.msg = "Mandatory";
    } else if (!profile.designation && (displayFields ? displayFields.includes(Fields.DESIGNATION) : true)) {
        validation.type = Fields.DESIGNATION;
        validation.msg = "Mandatory";
    } else if (profile.duration === null && (displayFields ? displayFields.includes(Fields.WORKING_SINCE) : true)) {
        validation.type = Fields.WORKING_SINCE;
        validation.msg = "Mandatory";
    } else if ((diffDays(new Date(profile.duration), new Date()) > 0
        || Number(getYear(new Date(profile.duration)) < Number(getYear(new Date(profile.dob)))))
        && (displayFields ? displayFields.includes(Fields.WORKING_SINCE) : true)) {
        validation.type = Fields.WORKING_SINCE;
        validation.msg = "Valid date required";
    } else if (differenceInMonths(new Date(), new Date(profile.duration)) >= profile.workExperienceMonths) {
      validation.type = Fields.WORKING_SINCE;
      validation.msg = "Date Is Greater Then Total Experience";
    } else if ((profile.workEmail && profile.workEmail.length > 0 && !isEmailValid(profile.workEmail))
        && (displayFields ? displayFields.includes(Fields.WORK_EMAIL) : true)) {
        validation.type = Fields.WORK_EMAIL;
        validation.msg = "Invalid Email";
    } else {
        validation.status = true;
    }
    return validation;
}
export function validateWorkAdressFields(profile, pincodeCheckLoading,
                                         pincodeCheckComplete, pincodecheck) {
  const validation = {
    status: false,
    type: null,
    msg: null,
    incompleteStatus: true,
  };
  if(!profile.workAddress)
    profile['workAddress'] = {};
  if (!profile.workAddress.house) {
    validation.type = Fields.WORK_ADDRESS_HOUSE;
    validation.msg = "Mandatory";
  } else if (!profile.workAddress.street) {
    validation.type = Fields.WORK_ADDRESS_STREET;
    validation.msg = "Mandatory";
  } else if (!profile.workAddress.locality) {
    validation.type = Fields.WORK_ADDRESS_LOCALITY;
    validation.msg = "Mandatory";
  } else if (!profile.workAddress.landmark) {
    validation.type = Fields.WORK_ADDRESS_LANDMARK;
    validation.msg = "Mandatory";
  } else if (!profile.workAddress.pincode
      || profile.workAddress.pincode.toString().length < 6
      || startsWithZero(profile.workAddress.pincode)) {
    validation.type = Fields.WORK_ADDRESS_PINCODE;
    validation.msg = "Mandatory";
  } else if (!pincodecheck) {
    validation.type = Fields.WORK_ADDRESS_PINCODE;
    validation.msg = "Invalid Pincode";
  } else {
    validation.status = true;
  }
  return validation;
}
export function validateEligibilityFields(profile, pincodeCheck) {
  const validation = {
    status: false,
    type: null,
    msg: null,
  };
  if (!profile.mobile || profile.mobile.length === 0) {
      validation.msg = "Mandatory";
      validation.type = Fields.MOBILE;
  } else if (!validatePhoneNumber(profile.mobile)) {
    validation.msg = "Invalid";
    validation.type = Fields.MOBILE;
  } else if ( !profile.address
      || !profile.address.pincode
      || profile.address.pincode.length < 6) {
    validation.msg = "Mandatory";
    validation.type =  Fields.CURR_ADDRESS_PINCODE;
  } else if (!pincodeCheck) {
      validation.msg = "Invalid Pincode";
      validation.type =  Fields.CURR_ADDRESS_PINCODE;
  } else if (profile.dob === null || isNaN(profile.dob)) {
    validation.msg = "Mandatory";
    validation.type = Fields.DOB;
  } else if (!isDateValid(profile.dob)) {
    validation.msg = "Invalid";
    validation.type = Fields.DOB;
  } else if (!profile.financeBasicInfo || !profile.financeBasicInfo.employmentType) {
    validation.msg = "Mandatory";
    validation.type = Fields.EMPLOYMENT_TYPE;
  } else if (!profile.financeBasicInfo.salaryMode) {
    validation.msg = "Mandatory";
    validation.type = Fields.SALARY_MODE;
  } else if (profile.workExperienceMonths === null) {
    validation.msg = "Mandatory";
    validation.type = Fields.WORK_EXPERIENCE_YEARS;
  } else if (!profile.financeBasicInfo || !profile.financeBasicInfo.netMonthlyIncome) {
    validation.msg = "Mandatory";
    validation.type = Fields.NET_MONTHLY_INCOME;
  } else if (profile.financeBasicInfo.netMonthlyIncome <= 0) {
    validation.msg = "Invalid";
    validation.type = Fields.NET_MONTHLY_INCOME;
  } else {
    validation.status = true;
  }
  return validation;
}
export function validateReference(reference, profile, order: number) {
  const validation = {
    status: false,
    type: null,
    msg: null,
  };

  if (
    !reference ||
    !reference.referenceName ||
    !validateName(reference.referenceName)
  ) {
    validation.msg = "Mandatory";
    validation.type = Fields[`REFERENCE_NAME_${order}`];
  } else if (!reference.referenceMobile) {
    validation.msg = "Mandatory";
    validation.type = Fields[`REFERENCE_MOBILE_${order}`];
  } else if (!validateReferencePhNumber(reference.referenceMobile, profile)) {
    validation.msg = "Invalid";
    validation.type = Fields[`REFERENCE_MOBILE_${order}`];
  } else if (!reference.referenceRelation) {
    validation.msg = "Mandatory";
    validation.type = Fields[`REFERENCE_RELATION_${order}`];
  } else {
    validation.status = true;
  }
  return validation;
}
export function validateResidence(profile, pincodeCheckLoading, pincodeCheckComplete, pincodecheck) {
  const validation = {
    status: false,
    type: null,
    msg: null,
    incompleteStatus: true,
  };
  if (!profile.residentType || profile.residentType === "Select") {
    validation.msg = "Mandatory";
    validation.type = Fields.RESIDENT_TYPE;
  } else if (profile.resTenure === null) {
    validation.msg = "Mandatory";
    validation.type = Fields.STAYING_SINCE;
  } else if (diffDays(new Date(profile.resTenure), new Date()) > 0) {
    validation.msg = "Entered date should not be after today's date";
    validation.type = Fields.STAYING_SINCE;
  } else if (Number(getYear(new Date(profile.resTenure)) < Number(getYear(new Date(profile.dob))))) {
    validation.msg = "Entered date should not be less than DOB";
    validation.type = Fields.STAYING_SINCE;
  } else if (profile.residentType === "Rented"
      && (!profile.resRentMonthly
          || startsWithZero(profile.resRentMonthly))) {
    validation.msg = "Mandatory";
    validation.type = Fields.RENT_MONTHLY;
  } else if (profile.residentType === "Rented" && (!profile.livingWith || profile.livingWith === "Select")) {
    validation.msg = "Mandatory";
    validation.type = Fields.LIVING_WITH;
  } else if (!profile.address.house) {
    validation.msg = "Mandatory";
    validation.type = Fields.CURR_ADDRESS_HOUSE;
  } else if (!profile.address.street) {
    validation.msg = "Mandatory";
    validation.type = Fields.CURR_ADDRESS_STREET;
  } else if (!profile.address.locality) {
    validation.msg = "Mandatory";
    validation.type = Fields.CURR_ADDRESS_LOCALITY;
  } else if (!profile.address.landmark) {
    validation.msg = "Mandatory";
    validation.type = Fields.CURR_ADDRESS_LANDMARK;
  } else if (!profile.address.pincode
      || profile.address.pincode.toString().length < 6
      || startsWithZero(profile.address.pincode)) {
    validation.msg = "Mandatory";
    validation.type = Fields.CURR_ADDRESS_PINCODE;
  } else if (pincodeCheckLoading || !pincodeCheckComplete) {
    validation.msg = "Validating pincode";
    validation.type = Fields.CURR_ADDRESS_PINCODE;
  } else if (!pincodecheck) {
    validation.msg = "Invalid pincode";
    validation.type = Fields.CURR_ADDRESS_PINCODE;
  } else {
    validation.status = true;
  }
  return validation;
}

export function validatePermanentAddress(profile, pincodeCheckLoading, pincodeCheckComplete, pincodecheck) {
  const validation = {
    status: false,
    type: null,
    msg: null,
    incompleteStatus: true,
  };
  if(!profile.permAddress)
    profile["permAddress"]={}
  if (!profile.residentTypePerm || profile.residentTypePerm === "Select") {
    validation.msg  = "Mandatory";
    validation.type = Fields.RESIDENT_TYPE_PERM;
  } else if (!profile.permAddress.house) {
    validation.msg  = "Mandatory";
    validation.type = Fields.PERM_ADDRESS_HOUSE;
  } else if (!profile.permAddress.street) {
    validation.msg  = "Mandatory";
    validation.type = Fields.PERM_ADDRESS_STREET;
  } else if (!profile.permAddress.locality) {
    validation.msg  = "Mandatory";
    validation.type = Fields.PERM_ADDRESS_LOCALITY;
  } else if (!profile.permAddress.landmark) {
    validation.msg  = "Mandatory";
    validation.type = Fields.PERM_ADDRESS_LANDMARK;
  } else if (!profile.permAddress.pincode) {
    validation.msg  = "Mandatory";
    validation.type = Fields.PERM_ADDRESS_PINCODE;
  } else if (profile.permAddress.pincode.toString().length !== 6
      || startsWithZero(profile.permAddress.pincode)) {
    validation.msg  = "Invalid pincode";
    validation.type = Fields.PERM_ADDRESS_PINCODE;
  } else if (pincodeCheckLoading || !pincodeCheckComplete) {
    validation.msg  = "Validating pincode";
    validation.type = Fields.PERM_ADDRESS_PINCODE;
  } else if (!pincodecheck) {
    validation.msg  = "Invalid pincode";
    validation.type = Fields.PERM_ADDRESS_PINCODE;
  } else {
    validation.status = true;
  }
  return validation;
}
export function calculateAge(dobString) {
  const dobStringSplitted = dobString.split("-");
  const birthMonth = Number(dobStringSplitted[1]);
  const birthDay = Number(dobStringSplitted[2]);
  const birthYear = Number(dobStringSplitted[0]);
  const todayDate = new Date();
  const todayYear = todayDate.getFullYear();
  const todayMonth = todayDate.getMonth();
  const todayDay = todayDate.getDate();
  let age = todayYear - birthYear;

  if (todayMonth < birthMonth - 1) {
    age--;
  }
  if (birthMonth - 1 === todayMonth && todayDay < birthDay) {
    age--;
  }
  return age;
}
export function isAgeEligible(dobInMilliseconds) {
  const bdayString = dateFormat(dobInMilliseconds);
  if (bdayString) {
    const age = calculateAge(bdayString);
    if (age >= 21 && age < 60) {
      return true;
    }
  }
  return false;
}
export function isDateValid(dateInMilliseconds: number): boolean {
  const givenYear = getYear(dateInMilliseconds);
  const currentYear = getYear(new Date());
  return currentYear - 100 < givenYear && givenYear <= currentYear;
}

export function validateProfileFields(profile, displayFields, loanInfo?) {
  let validation = {
    status: false,
    type: null,
    msg: null,
    incompleteStatus: true,
  };
  if (profile.name === null && (displayFields ? displayFields.includes(Fields.NAME) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.NAME;
  } else if (loanInfo && (!loanInfo.purpose || loanInfo.purpose === "Select") && (displayFields ? displayFields.includes(Fields.LOAN_PURPOSE) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.LOAN_PURPOSE;
  } else if (loanInfo && (loanInfo.purpose && loanInfo.purpose === "Other" && !loanInfo.purposeRemark) &&
    (displayFields ? displayFields.includes(Fields.LOAN_PURPOSE_REMARK) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.LOAN_PURPOSE_REMARK;
  } else if (!validateName(profile.name) && (displayFields ? displayFields.includes(Fields.NAME) : true)) {
    validation.msg = "Invalid";
    validation.type = Fields.NAME;
  } else if (profile.dob === null && (displayFields ? displayFields.includes(Fields.DOB) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.DOB;
  } else if ((diffYears(new Date(), new Date(profile.dob)) < 21
      || diffYears(new Date(), new Date(profile.dob)) > 60) && (displayFields ? displayFields.includes(Fields.DOB) : true)) {
    validation.msg = "Age should be between 21 - 60";
    validation.type = Fields.DOB;
  } else if (!profile.gender && (displayFields ? displayFields.includes(Fields.GENDER) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.GENDER;
  } else  if (!profile.relationshipStatus && (displayFields ? displayFields.includes(Fields.RELATIONSHIP_STATUS) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.RELATIONSHIP_STATUS;
  } else if ((!profile.education || profile.education === "Select Education")
      && (displayFields ? displayFields.includes(Fields.HIGHEST_EDUCATION) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.HIGHEST_EDUCATION;
  } else if (!profile.panNumber && (displayFields ? displayFields.includes(Fields.PAN_NUMBER) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.PAN_NUMBER;
  } else if (!isValidPan(profile.panNumber) && (displayFields ? displayFields.includes(Fields.PAN_NUMBER) : true)) {
    validation.msg = "Invalid";
    validation.type = Fields.PAN_NUMBER;
  } else if (!profile.fatherOrSpouseName && (displayFields ? displayFields.includes(Fields.FATHERS_NAME) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.FATHERS_NAME;
  } else if (!validateName(profile.fatherOrSpouseName) && (displayFields ? displayFields.includes(Fields.FATHERS_NAME) : true)) {
    validation.msg = "Invalid";
    validation.type = Fields.FATHERS_NAME;
  } else if (!profile.mothersName && (displayFields ? displayFields.includes(Fields.MOTHERS_NAME) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.MOTHERS_NAME;
  } else if (!validateName(profile.mothersName) && (displayFields ? displayFields.includes(Fields.MOTHERS_NAME) : true)) {
    validation.msg = "Invalid";
    validation.type = Fields.MOTHERS_NAME;
  } else if ((!profile.financeBasicInfo || profile.financeBasicInfo.numDependents === null)
      && (displayFields ? displayFields.includes(Fields.TOTAL_DEPENDENTS) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.TOTAL_DEPENDENTS;
  } else if ((!profile.mobile
      || profile.mobile.length < 10
      || !isMobile(profile.mobile)
      || startsWithZero(profile.mobile)) && (displayFields ? displayFields.includes(Fields.MOBILE) : true)) {
    validation.msg = "Mandatory";
    validation.type = Fields.MOBILE;
  } else if ((profile.alternateMobileNumbers !== null
    && !isMobile(profile.alternateMobileNumbers[0]))
    && (displayFields ? displayFields.includes(Fields.ALTERNATE_MOBILE) : true)) {
    validation.msg = "Invalid Number";
    validation.type = Fields.ALTERNATE_MOBILE;
  }else {
    validation.status = true;
  }
  return validation;
}

export function validateBankAcFields(profile: IProfile, reEnteredBankAcNumber: string) {
  const validation = {
    status: false,
    type: null,
    msg: null,
  };
  const indexOfLastBankAcDetails = profile.bankAccounts.length - 1;
  if (!profile.bankAccounts) {
    validation.msg = "Mandatory";
    validation.type = Fields.BANK_AC_NUMBER;
  } else if (!profile.bankAccounts[indexOfLastBankAcDetails].accountNumber) {
    validation.msg = "Mandatory";
    validation.type = Fields.BANK_AC_NUMBER;
  } else if (!reEnteredBankAcNumber) {
    validation.msg = "Mandatory";
    validation.type = Fields.RE_ENTER_BANK_AC_NUMBER;
  } else if (profile.bankAccounts[indexOfLastBankAcDetails].accountNumber !== reEnteredBankAcNumber) {
    validation.msg = "Bank Account Number Mismatched";
    validation.type = Fields.BANK_AC_NUMBER;
  } else if (!profile.bankAccounts[indexOfLastBankAcDetails].ifsc) {
    validation.msg = "Mandatory";
    validation.type = Fields.IFSC_CODE;
  } else if (profile.bankAccounts[indexOfLastBankAcDetails].ifsc.length < 11) {
    validation.msg = "Wrong IFSC";
    validation.type = Fields.IFSC_CODE;
  } else {
    validation.status = true;
  }
  return validation;
}
export function isUserEligible(profile, minSalaryCutoff) {
  return (
    profile.mobile &&
    isAgeEligible(profile.dob) &&
    profile.financeBasicInfo &&
    profile.financeBasicInfo.salaryMode === "BANK_TRANSFER" &&
    profile.financeBasicInfo.employmentType === "SALARIED" &&
    profile.financeBasicInfo.netMonthlyIncome >= minSalaryCutoff &&
    profile.workExperienceMonths >= 12
  );
}
export function isBasicProfileInfoCompleted(profile) {
  return (
    profile.name &&
    profile.panNumber &&
    profile.mobile &&
    profile.dob !== null &&
    profile.fatherOrSpouseName &&
    profile.mothersName &&
    profile.education &&
    profile.financeBasicInfo.numDependents > -1 &&
    profile.gender &&
    profile.relationshipStatus
  );
}
export function isResidenceInfoCompleted(profile) {
  return (
    profile.residentType &&
    profile.resTenure !== null &&
    profile.residentType &&
    profile.address &&
    profile.address.house &&
    profile.address.street &&
    profile.address.locality &&
    profile.address.landmark &&
    profile.address.pincode &&
    profile.permAddress &&
    profile.permAddress.house &&
    profile.permAddress.street &&
    profile.permAddress.locality &&
    profile.permAddress.landmark &&
    profile.permAddress.pincode
  );
}
export function isV3ResidenceInfoCompleted(profile) {
  return (
      profile.residentType &&
      profile.resTenure !== null &&
      profile.address &&
      profile.address.house &&
      profile.address.street &&
      profile.address.locality &&
      profile.address.landmark &&
      profile.address.pincode
  );
}
export function isEmployementInfoCompleted(profile) {
  return (
    profile.currentEmployer &&
    profile.designation &&
    profile.duration !== null &&
    profile.workExperienceMonths &&
    profile.workAddress &&
    profile.workAddress.house &&
    profile.workAddress.street &&
    profile.workAddress.locality &&
    profile.workAddress.landmark &&
    profile.workAddress.pincode
  );
}
export function isLoanInfoCompleted(loanInfo) {
  return loanInfo && loanInfo.amount && loanInfo.tenure && loanInfo.purpose;
}
export function isV3LoanInfoCompleted(loanInfo) {
  return loanInfo && loanInfo.amount && loanInfo.tenure;
}
export function isReferencesCompleted(profile) {
  return profile && profile.references && profile.references.length >= 2;
}
export function isV3BasicProfileInfoCompleted(profile) {
  return (
      profile.name &&
      profile.panNumber &&
      profile.mobile &&
      profile.dob !==null &&
      profile.gender);
}
export function isV3EmployementInfoCompleted(profile) {
  return (
      profile.currentEmployer &&
      profile.designation &&
      profile.duration !== null
  );
}
export function getCompletedPages(
  profile: IProfile,
  documents,
  bankStatement,
  userStatus: IUserStatus,
) {
  const completePages = [];
  if (profile) {
    if (isUserEligible(profile, userStatus.loanEligibilityCriteria.minSalaryCutoff) && (profile.mobileOtpVerified || userStatus.isTruecallerVerified)) {
      if (completePages.indexOf(Screens.GET_STARTED) === -1) {
        completePages.splice(0, 0, Screens.GET_STARTED);
      }
    }
    if (isBasicProfileInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.BASIC_PERSONAL) === -1) {
        completePages.splice(1, 0, Screens.BASIC_PERSONAL);
      }
    }
    if (isResidenceInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.RESIDENCE) === -1) {
        completePages.splice(2, 0, Screens.RESIDENCE);
      }
    }
    if (isEmployementInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.EMPLOYMENT) === -1) {
        completePages.splice(3, 0, Screens.EMPLOYMENT);
      }
    }
    if (isLoanInfoCompleted(profile.loanRequest)) {
      if (completePages.indexOf(Screens.LOAN_AMOUNT_TENURE) === -1) {
        completePages.splice(4, 0, Screens.LOAN_AMOUNT_TENURE);
      }
    }
  }
  if (isReferencesCompleted(profile)) {
    completePages.splice(5, 0, Screens.REFERENCES);
  }
  if (isMandatoryDocsComplete(documents, getMandatoryDocTypes())) {
    if (completePages.indexOf(Screens.DOCUMENTS) === -1) {
      completePages.splice(6, 0, Screens.DOCUMENTS);
    }
  }
  if (isBankStatementComplete(bankStatement)) {
    if (completePages.indexOf(Screens.BANK_STATEMENT) === -1) {
      completePages.splice(7, 0, Screens.BANK_STATEMENT);
    }
  }
  return completePages;
}

export function getV3CompletePages(
    profile: IProfile,
    bankStatement,
    userStatus: IUserStatus
) {
  const completePages = [];
  if (profile) {
    if (isUserEligible(profile, userStatus.loanEligibilityCriteria.minSalaryCutoff) && (profile.mobileOtpVerified || userStatus.isTruecallerVerified)) {
      if (completePages.indexOf(Screens.GET_STARTED) === -1) {
        completePages.splice(0, 0, Screens.GET_STARTED);
      }
    }
    if (isV3BasicProfileInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.BASIC_PERSONAL) === -1) {
        completePages.splice(1, 0, Screens.BASIC_PERSONAL);
      }
    }
    if (isV3ResidenceInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.RESIDENCE) === -1) {
        completePages.splice(2, 0, Screens.RESIDENCE);
      }
    }
    if (isV3EmployementInfoCompleted(profile)) {
      if (completePages.indexOf(Screens.EMPLOYMENT) === -1) {
        completePages.splice(3, 0, Screens.EMPLOYMENT);
      }
    }
    if (isV3LoanInfoCompleted(profile.loanRequest)) {
      if (completePages.indexOf(Screens.LOAN_AMOUNT_TENURE) === -1) {
        completePages.splice(4, 0, Screens.LOAN_AMOUNT_TENURE);
      }
    }
  }
  if (isBankStatementComplete(bankStatement)) {
    if (completePages.indexOf(Screens.BANK_STATEMENT) === -1) {
      completePages.splice(5, 0, Screens.BANK_STATEMENT);
    }
  }
  return completePages;
}

export function intersection<T>(a: T[], b: T[]): T[] {
  if (!a || !b) {
    return [];
  }
  if (b.length > a.length) {
    const t = b;
    b = a;
    a = t;
  }
  return a
    .filter(e => {
      return b.indexOf(e) > -1;
    })
    .filter((e, i, c) => {
      return c.indexOf(e) === i;
    });
}
export enum Direction {
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD"
}

export function getLandingFlag(completedPages) {
  if (completedPages.length === allScreens.length) {
    return Flags.showFormComplete;
  }
  if (completedPages.indexOf(Screens.GET_STARTED) === -1) {
    return Flags.showGetStarted;
  }
  if (completedPages.indexOf(Screens.BASIC_PERSONAL) === -1) {
    return Flags.showPersonalInfo;
  }
  if (completedPages.indexOf(Screens.RESIDENCE) === -1) {
    return Flags.showResidenceInfo;
  }
  if (completedPages.indexOf(Screens.EMPLOYMENT) === -1) {
    return Flags.showEmploymentInfo;
  }
  if (completedPages.indexOf(Screens.LOAN_AMOUNT_TENURE) === -1) {
    return Flags.showLoanAmountTenure;
  }
  if (completedPages.indexOf(Screens.REFERENCES) === -1) {
    return Flags.showReferences;
  }
  if (completedPages.indexOf(Screens.DOCUMENTS) === -1) {
    return Flags.showDocumentsInfo;
  }
  if (completedPages.indexOf(Screens.BANK_STATEMENT) === -1) {
    return Flags.showBankStatementInfo;
  }
}

export function getV3LandingFlag(completedPages) {
  if (completedPages.length === v3Screens.length) {
    return Flags.showFormComplete;
  }
  if (completedPages.indexOf(Screens.GET_STARTED) === -1) {
    return Flags.showGetStarted;
  }
  if (completedPages.indexOf(Screens.BASIC_PERSONAL) === -1) {
    return Flags.showPersonalInfo;
  }
  if (completedPages.indexOf(Screens.RESIDENCE) === -1) {
    return Flags.showResidenceInfo;
  }
  if (completedPages.indexOf(Screens.EMPLOYMENT) === -1) {
    return Flags.showEmploymentInfo;
  }
  if (completedPages.indexOf(Screens.LOAN_AMOUNT_TENURE) === -1) {
    return Flags.showLoanAmountTenure;
  }
  if (completedPages.indexOf(Screens.BANK_STATEMENT) === -1) {
    return Flags.showBankStatementInfo;
  }
}

export function getCompletionDetails(
  profile: IProfile,
  documents,
  bankStatement,
  userStatus: IUserStatus
) {
  const completePages = getCompletedPages(
    profile,
    documents,
    bankStatement,
    userStatus,
  );
  const v3CompletePages = getV3CompletePages(
      profile,
      bankStatement,
      userStatus,
      );

  const completionPercent = Math.round(
    (completePages.length * 100) / allScreens.length
  );
  return {
    completePages,
    completionPercent,
    v3CompletePages,
  };
}

export function getDocTypes() {
  return [
    DocTypes.SELFIE,
    DocTypes.PAN,
    //  DocTypes.AADHAAR,
    DocTypes.CURRENT_ADDRESS_PROOF,
    DocTypes.PAY_SLIP_1,
    DocTypes.RENTAL_AGREEMENT,
    DocTypes.OFFER_LETTER,
    DocTypes.OTHER
  ];
}

export function getDocumentsToApply() {
  return [
    DocTypes.SELFIE,
    DocTypes.PAN,
    // DocTypes.AADHAAR,
    DocTypes.PAY_SLIP_1,
  ];
}

export function getConsentDocuments() {
    return [
        DocTypes.AADHAAR,
        DocTypes.CANCELLED_CHEQUE,
        DocTypes.CURRENT_ADDRESS_PROOF,
        DocTypes.SELFIE,
        DocTypes.PAN,
    ]
}

export function getDocErrors() {
  return [
    { type: DocTypes.SELFIE, message: "SELFIE REQUIRED" },
    { type: DocTypes.PAN, message: "PAN REQUIRED" },
    { type: DocTypes.PAY_SLIP_1, message: "PAY SLIP REQUIRED" },
    {
      type: DocTypes.CURRENT_ADDRESS_PROOF,
      message: "CURRENT ADDRESS PROOF REQUIRED"
    },
    { type: DocTypes.OFFER_LETTER, message: "OFFER LETTER REQUIRED" },
    // { type: DocTypes.AADHAAR, message: "AADHAAR REQUIRED" },
    { type: DocTypes.RENTAL_AGREEMENT, message: "RENTAL AGREEMENT REQUIRED" },
    { type: DocTypes.OTHER, message: "OTHER REQUIRED" }
  ];
}

export function getDocUploadPortalDocTypes() {
  return [
    DocTypes.SELFIE,
    DocTypes.PAN,
    // DocTypes.AADHAAR,
    DocTypes.CURRENT_ADDRESS_PROOF,
    DocTypes.PAY_SLIP_1
  ];
}

export function getMandatoryDocTypes() {
  return [
    DocTypes.SELFIE,
    DocTypes.PAN
    // DocTypes.AADHAAR,
  ];
}

export function getMonthName(index) {
  const monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  return monthList[index];
}

export const dateFormat = (date, def = null) => {
  return date !== null ? format(new Date(date), "YYYY-MM-DD") : def;
};
export function renderDatePicker(
  value: number | Date,
  placeholder,
  fieldName,
  errorMsg,
  onChangeHandler,
  containerClass?: string,
  labelStyle?: object,
  inputClass?: string,

) {
  const formClassName = classnames(`form-group ${containerClass ? containerClass : "px-3 py-2"}`, {
    "form-group-error": errorMsg !== null
  });
  const defaultLableStyle = { fontSize: 14, fontWeight: 600, color: "#575757" };
  const currentLabelStyle = labelStyle ? labelStyle : defaultLableStyle;
  return (
    <div className={formClassName}>
      <label
        style={currentLabelStyle}
        htmlFor={fieldName}
      >
        {placeholder}
      </label>
      {errorMsg && (
        <label
          style={{ fontSize: 15 }}
          htmlFor={fieldName}
          className="label-error"
        >
          {errorMsg}
        </label>
      )}
      <input
        id={fieldName}
        type="date"
        className={`form-control ${inputClass ? inputClass : "dob-box" }`}
        data-date-inline-picker="true"
        placeholder={placeholder}
        onChange={e => onChangeHandler(fieldName, e.target.value)}
        value={value !== null ? dateFormat(value) : ""}
      />
    </div>
  );
}

export function renderTextField(
  type,
  placeholder,
  value,
  fieldName,
  onChangeHandler,
  min,
  max,
  maxLength,
  errorMsg: string,
  disabled?: boolean,
  label?: string,
  visibility?: boolean,
  showLoading?: boolean,
  showCheck?: boolean,
  display?: boolean,
  paddingX?: string,
  paddingT?: string,
  paddingB?: string,
  marginX?: string,
  marginY?: string,
  inputClassName?: string,
  labelStyle?: object,
) {
  const formClassName = classnames(
    `form-group px-${paddingX ? paddingX : "3"}
  pt-${paddingT ? paddingT : "2"}
  pb-${paddingB ? paddingB : "2"}
  ${marginX ? `mx-${marginX}` : ""} ${marginY ? `my-${marginY}` : ""}`,
    { "form-group-error": errorMsg !== null }
  );
  const defaultLableStyle = {
    display: `${display ? "iniline-block" : "none"}`,
    fontSize: 14,
    fontWeight: 600,
    color: "#575757",
    visibility: visibility ? "visible" : "hidden"
  };
  const currentLabelStyle = labelStyle ? labelStyle : defaultLableStyle;
  return (
    <div className={formClassName}>
      <label
        style={currentLabelStyle}
        htmlFor={fieldName}
      >
        {label}
      </label>
      {errorMsg && (
        <label
          style={{ fontSize: 15}}
          htmlFor={fieldName}
          className="label-error"
        >
          {errorMsg}
        </label>
      )}
      <div className="input-group">
        <input
          id={fieldName}
          className={`form-control form-field ${inputClassName}`}
          type={type}
          placeholder={placeholder}
          value={value !== null ? value : ""}
          min={min}
          max={max}
          maxLength={maxLength}
          disabled={disabled ? disabled : false}
          onChange={e => onChangeHandler(fieldName, e.target.value)}
        />
        <div className="input-group-append">
          {showCheck && (
            <span className="input-group-text" style={{ borderRadius: 0 }}>
              <i className="fa fa-check-circle" />
            </span>
          )}
          {showLoading && (
            <span className="input-group-text" style={{ borderRadius: 0 }}>
              <i
                className="fa fa-circle-o-notch fa-spin"
                style={{ color: "#237fcc" }}
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
export function renderButtonRadios(
  btnList,
  label,
  fieldName,
  errorMsg,
  onChangeHandler,
  labelStyle?: object,
  containerClass?: string,
) {
  const formClassName = classnames(`form-group ${containerClass ? containerClass : "px-3 py-2"}`, {
    "form-group-error": errorMsg !== null
  });
  const defaultLabelStyle = { fontSize: 14, fontWeight: 600, color: "#575757" }
  const currentLabelStyle = labelStyle ? labelStyle : defaultLabelStyle;
  return (
    <div className={formClassName}>
      <label style={currentLabelStyle}>
        {label}
      </label>
      {errorMsg && (
        <label
          style={{ fontSize: 15 }}
          htmlFor={fieldName}
          className="label-error"
        >
          {errorMsg}
        </label>
      )}
      <div className="radio-group">
        {btnList.map((item, index) => {
          return (
              renderButtonRadio(
                index,
                item.name,
                item.value,
                item.fieldName,
                item.checked,
                onChangeHandler,
                item.id
              )
          )
        })}
      </div>
    </div>
  );
}

function renderButtonRadio(
  key,
  name,
  value,
  fieldName,
  checked,
  onChangeHandler,
  id?
) {
  const classname = classnames(
    checked ? "radio-btn-selected" : "radio-btn"
  );
  return (
    <button
      type={"button"}
      key={key}
      className={classname}
      id={id}
      onClick={() => onChangeHandler(fieldName, value)}
    >
      {name}
    </button>
  );
}

export function renderSelect(
  name,
  options,
  value,
  fieldName,
  errorMsg,
  onChangeHandler,
  disabled?: boolean,
  containerClass?: string,
  labelStyle?: object,
  inputClass?: string,
) {
  const formClassName = classnames(`form-group ${containerClass ? containerClass : "px-3 py-2"}`, {
    "form-group-error": errorMsg !== null
  });
  const defaultStyle = {fontSize: 14, color: "rgb(87, 87, 87)", fontWeight: 600};
  const defaultInputStyle = {
    borderRadius: ".25rem",
    backgroundColor: "#f9f9f9",
    border: "1px solid #e8eaec",
  };
  return (
    <div className={formClassName}>
      <label
        style={labelStyle ? labelStyle : defaultStyle}
        htmlFor={fieldName}
      >
        {name}
      </label>
      {errorMsg && (
        <label
          style={{ fontSize: 14 }}
          htmlFor={fieldName}
          className="label-error"
        >
          {errorMsg}
        </label>
      )}
      <select
        id={fieldName}
        className={`form-control ${inputClass ? inputClass : ""}`}
        value={value}
        style={inputClass ? {} : defaultInputStyle}
        onChange={e => onChangeHandler(fieldName, e.target.value)}
        disabled={disabled ? disabled : false}
      >
        {options.map((item, index) => {
          return (
            <option value={item.value} key={index}>
              {item.name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export function renderAutoComplete(
  name,
  options,
  value,
  fieldName,
  errorMsg,
  onChangeHandler,
  disabled?: boolean,
  labelStyle?: object,
  containerClass?: string,
  inputClass?: string,
) {
  const formClassName = classnames(`form-group ${containerClass ? containerClass : "px-3 py-2"}`, {
    "form-group-error": errorMsg !== null
  });
  const defaultStyle = {fontSize: 15, color: "#292525" };
  const defaultInputStyle = {
    borderRadius: ".25rem",
    border: "1px solid #e8eaec",
    backgroundColor: "#f9f9f9"
  };

  return (
    <div className={formClassName}>
      <label style={labelStyle ? labelStyle : defaultStyle} htmlFor={fieldName}>
        {name}
      </label>
      {errorMsg && (
        <label
          style={{ fontSize: 15 }}
          htmlFor={fieldName}
          className="label-error"
        >
          {errorMsg}
        </label>
      )}
      <input
        list={fieldName}
        name={fieldName}
        className={`form-control ${inputClass ? inputClass : ""}`}
        style={inputClass ? {} : defaultInputStyle}
        value={value}
        onChange={e => onChangeHandler(fieldName, e.target.value)}
        disabled={disabled ? disabled : false}
      />
      <datalist id={fieldName}>
        {options.map((item, index) => {
          return <option value={item.value} key={index} />;
        })}
      </datalist>
    </div>
  );
}
export function getTotalWorkExperienceInMonths(value, type, profile) {
  const workExpYears = Math.floor(profile.workExperienceMonths / 12);
  const workExpMonths = Math.floor(profile.workExperienceMonths % 12);
  if (value === 0 && (workExpYears === 0 || workExpMonths === 0)) {
    return null;
  }
  if (type === Fields.WORK_EXPERIENCE_YEARS) {
    if(Number(value)>99){
      return null;
    }
    return (Number(value) * 12) + workExpMonths;
  } else if (type === Fields.WORK_EXPERIENCE_MONTHS) {
    return (workExpYears * 12) + Number(value);
  }
}
export function update(
  profile: IProfile,
  fieldName: Fields,
  value: string | number,
) {
  profile.nominees =
      profile.nominees === null || profile.nominees.length === 0 ?
          [
            {
              name: null,
              relationShip: null,
              dob: null,
              mobile: null,
            },
          ] :
      profile.nominees;
  profile.address =
    profile.address == null
      ? {
          house: null,
          street: null,
          locality: null,
          landmark: null,
          pincode: null
        }
      : profile.address;
  profile.permAddress =
    profile.permAddress == null
      ? {
          house: null,
          street: null,
          locality: null,
          landmark: null,
          pincode: null
        }
      : profile.permAddress;

  profile.workAddress =
    profile.workAddress == null
      ? {
          house: null,
          street: null,
          locality: null,
          landmark: null,
          pincode: null
        }
      : profile.workAddress;
  profile.loanRequest =
      profile.loanRequest === null ?
      {
        amount: null,
        tenure: null,
        purpose: null,
        purposeRemark: null,
        additionalLoanInfo: null,
      } : profile.loanRequest;
  profile.bankAccounts =
      profile.bankAccounts ?
          profile.bankAccounts :
          [{
            beneficiaryName: null,
            bankName: null,
            ifsc: null,
            accountNumber: null,
            accountType: null,
            purposeType: null,
          }];
  if (fieldName === Fields.NAME) {
    if (String(value).length <= 250) {
      profile.name = String(value);
    }
  } else if (fieldName === Fields.MOTHERS_NAME) {
    if (String(value).length <= 250) {
      profile.mothersName = String(value);
    }
  } else if (fieldName === Fields.FATHERS_NAME) {
    if (String(value).length <= 250) {
      profile.fatherOrSpouseName = String(value);
    }
  } else if (fieldName === Fields.PAN_NUMBER) {
    if (String(value).length <= 10) {
      profile.panNumber = String(value).toUpperCase();
    }
  } else if (fieldName === Fields.DOB) {
    profile.dob = value === "" ? null : new Date(String(value)).getTime();

  } else if (fieldName === Fields.MOBILE) {
    const regexForNumber = /^\d+$/;
    if (String(value).length <= 10 && regexForNumber.test(String(value))) {
      profile.mobile = String(value);
    } else if (String(value) === "") {
      profile.mobile = null;
    }
  } else if (fieldName === Fields.CURR_ADDRESS_HOUSE) {
    if (String(value).length <= 250) {
      profile.address.house = String(value);
    }
  } else if (fieldName === Fields.CURR_ADDRESS_STREET) {
    if (String(value).length <= 250) {
      profile.address.street = String(value);
    }
  } else if (fieldName === Fields.CURR_ADDRESS_LOCALITY) {
    if (String(value).length <= 250) {
      profile.address.locality = String(value);
    }
  } else if (fieldName === Fields.CURR_ADDRESS_LANDMARK) {
    if (String(value).length <= 250) {
      profile.address.landmark = String(value);
    }
  } else if (fieldName === Fields.CURR_ADDRESS_PINCODE) {
    profile.address.pincode = String(value).slice(0, 6);
  } else if (fieldName === Fields.GENDER) {
    profile.gender = String(value);
  } else if (fieldName === Fields.RELATIONSHIP_STATUS) {
    profile.relationshipStatus = String(value);
  } else if (fieldName === Fields.RESIDENT_TYPE) {
    profile.residentType = String(value);
  } else if (fieldName === Fields.LIVING_WITH) {
    profile.livingWith = String(value);
  } else if (fieldName === Fields.RESIDENT_TYPE_PERM) {
    profile.residentTypePerm = String(value);
  } else if (fieldName === Fields.RENT_MONTHLY) {
    if (String(value).length <= 10) {
      profile.resRentMonthly = value === "" ? null : Number(value);
    }
  } else if (fieldName === Fields.STAYING_SINCE) {
    profile.resTenure = value === "" ? null : new Date(String(value)).getTime();
  } else if (fieldName === Fields.HIGHEST_EDUCATION) {
    profile.education = String(value);
  } else if (fieldName === Fields.EMPLOYER_TYPE) {
    profile.employerType = String(value);
  } else if (fieldName === Fields.EMPLOYEE_ID) {
    profile.employeeId = String(value);
  } else if (fieldName === Fields.PERM_ADDRESS_HOUSE) {
    if (String(value).length <= 250) {
      profile.permAddress.house = String(value);
    }
  } else if (fieldName === Fields.PERM_ADDRESS_STREET) {
    if (String(value).length <= 250) {
      profile.permAddress.street = String(value);
    }
  } else if (fieldName === Fields.PERM_ADDRESS_LOCALITY) {
    if (String(value).length <= 250) {
      profile.permAddress.locality = String(value);
    }
  } else if (fieldName === Fields.PERM_ADDRESS_LANDMARK) {
    if (String(value).length <= 250) {
      profile.permAddress.landmark = String(value);
    }
  } else if (fieldName === Fields.PERM_ADDRESS_PINCODE) {
    profile.permAddress.pincode = String(value).slice(0, 6);
  } else if (fieldName === Fields.CURRENT_EMPLOYER) {
    if (String(value).length <= 250) {
      profile.currentEmployer = String(value);
    }
  } else if (fieldName === Fields.DESIGNATION) {
    if (String(value).length <= 250) {
      profile.designation = String(value);
    }
  } else if (fieldName === Fields.WORK_EXPERIENCE_YEARS) {
    profile.workExperienceMonths = getTotalWorkExperienceInMonths(Math.abs(Number(value)), Fields.WORK_EXPERIENCE_YEARS, profile);
  } else if (fieldName === Fields.WORK_EXPERIENCE_MONTHS) {
    profile.workExperienceMonths = getTotalWorkExperienceInMonths(Math.abs(Number(value)), Fields.WORK_EXPERIENCE_MONTHS, profile);
  } else if (fieldName === Fields.WORKING_SINCE) {
    profile.duration = value === "" ? null : new Date(String(value)).getTime();
  } else if (fieldName === Fields.WORK_EMAIL) {
    if (String(value).length <= 250) {
      profile.workEmail = String(value);
    }
  } else if (fieldName === Fields.WORK_ADDRESS_HOUSE) {
    if (String(value).length <= 250) {
      profile.workAddress.house = String(value);
    }
  } else if (fieldName === Fields.WORK_ADDRESS_STREET) {
    if (String(value).length <= 250) {
      profile.workAddress.street = String(value);
    }
  } else if (fieldName === Fields.WORK_ADDRESS_LOCALITY) {
    if (String(value).length <= 250) {
      profile.workAddress.locality = String(value);
    }
  } else if (fieldName === Fields.WORK_ADDRESS_LANDMARK) {
    if (String(value).length <= 250) {
      profile.workAddress.landmark = String(value);
    }
  } else if (fieldName === Fields.WORK_ADDRESS_PINCODE) {
    profile.workAddress.pincode = String(value).slice(0, 6);
  } else if (fieldName === Fields.NET_MONTHLY_INCOME) {
    if (String(value).length <= 10) {
      if (!profile.financeBasicInfo) {
        const financeBasicInfo: IFinanceBasicInfo = {
          netMonthlyIncome: value === "" ? null : Number(value),
          numDependents: null,
          creditLimit: null,
          salaryMode: null,
          employmentType: null,
          totalCurrentEmi: null,
        };
        profile.financeBasicInfo = financeBasicInfo;
      } else {
        profile.financeBasicInfo.netMonthlyIncome = value === "" ? null : Number(value);
      }
    }
  } else if (fieldName === Fields.TOTAL_DEPENDENTS) {
    if (String(value).length <= 2) {
      if (!profile.financeBasicInfo) {
        const financeBasicInfo: IFinanceBasicInfo = {
          netMonthlyIncome: null,
          numDependents: value === "" ? null : Math.abs(Number(value)),
          creditLimit: null,
          salaryMode: null,
          employmentType: null,
          totalCurrentEmi: null,
        };
        profile.financeBasicInfo = financeBasicInfo;
      } else {
        profile.financeBasicInfo.numDependents = value === "" ? null : Math.abs(Number(value));
      }
    }
  } else if (fieldName === Fields.SALARY_MODE) {
    if (!profile.financeBasicInfo) {
      const financeBasicInfo: IFinanceBasicInfo = {
        netMonthlyIncome: null,
        numDependents: null,
        creditLimit: null,
        salaryMode: SalaryMode[value],
        employmentType: null,
        totalCurrentEmi: null,
      };
      profile.financeBasicInfo = financeBasicInfo;
    } else {
      profile.financeBasicInfo.salaryMode = SalaryMode[value];
    }
  } else if (fieldName === Fields.EMPLOYMENT_TYPE) {
    if (!profile.financeBasicInfo) {
      const financeBasicInfo: IFinanceBasicInfo = {
        netMonthlyIncome: null,
        numDependents: null,
        creditLimit: null,
        salaryMode: null,
        employmentType: EmploymentType[value],
        totalCurrentEmi: null,
      };
      profile.financeBasicInfo = financeBasicInfo;
    } else {
      profile.financeBasicInfo.employmentType = EmploymentType[value];
    }
  } else if (fieldName === Fields.CREDIT_LIMIT) {
    if (String(value).length <= 250) {
      if (!profile.financeBasicInfo) {
        const financeBasicInfo: IFinanceBasicInfo = {
          netMonthlyIncome: null,
          numDependents: null,
          creditLimit: Number(value),
          salaryMode: null,
          employmentType: null,
          totalCurrentEmi: null,
        };
        profile.financeBasicInfo = financeBasicInfo;
      } else {
        profile.financeBasicInfo.creditLimit = Number(value);
      }
    }
  } else if (fieldName === Fields.TOTAL_CURRENT_EMI) {
    if (!profile.financeBasicInfo) {
      const financeBasicInfo: IFinanceBasicInfo = {
        netMonthlyIncome: null,
        numDependents: null,
        creditLimit: null,
        salaryMode: null,
        employmentType: null,
        totalCurrentEmi: Math.abs(Number(value)),
      };
      profile.financeBasicInfo = financeBasicInfo;
    } else {
      profile.financeBasicInfo.totalCurrentEmi = Math.abs(Number(value));
    }
  } else if (fieldName === Fields.ALTERNATE_MOBILE) {
    if (String(value).length === 0) {
      profile.alternateMobileNumbers = null;
    } else if (String(value).length <= 10) {
      profile.alternateMobileNumbers = [String(value)];
    }
  } else if (fieldName === Fields.LOAN_PURPOSE) {
      profile.loanRequest = {...profile.loanRequest, purpose: String(value)};
  } else if (fieldName === Fields.LOAN_PURPOSE_REMARK) {
    profile.loanRequest = {...profile.loanRequest, purposeRemark: String(value)};
  } else if (fieldName === Fields.LOAN_AMOUNT) {
      profile.loanRequest = {...profile.loanRequest, amount: Number(value)};
  } else if (fieldName === Fields.LOAN_TENURE_MONTHS) {
    profile.loanRequest = {...profile.loanRequest, tenure: Number(value)};
  } else if (fieldName === Fields.NOMINEE_NAME) {
    profile.nominees[0].name = String(value);
  } else if (fieldName === Fields.NOMINEE_RELATION) {
    profile.nominees[0].relationShip = String(value);
  } else if (fieldName === Fields.NOMINEE_MOBILE) {
    profile.nominees[0].mobile = String(value);
  } else if (fieldName === Fields.NOMINEE_DOB) {
    profile.nominees[0].dob = new Date(dateFormat(value)).getTime();
  } else if (fieldName === Fields.SELECT_CURRENT_EMPLOYER) {
    if (String(value).length <= 255) {
      profile.currentEmployer = String(value);
    }
  } else if (fieldName === Fields.BANK_AC_NUMBER) {
    const indexOfLastBankAccount = profile.bankAccounts.length - 1;
    profile.bankAccounts[indexOfLastBankAccount].accountNumber = String(value).toUpperCase();
  } else if (fieldName === Fields.IFSC_CODE && String(value).length < 12) {
    const indexOfLastBankAccount = profile.bankAccounts.length - 1;
    profile.bankAccounts[indexOfLastBankAccount].ifsc = String(value).toUpperCase();
  }  else if (fieldName === Fields.BANK_NAME) {
    const indexOfLastBankAccount = profile.bankAccounts.length - 1;
    profile.bankAccounts[indexOfLastBankAccount].bankName = String(value);
  }
  return profile;
}

export function getContentType(
  content: string
): { ext: string; mime: string; skipBase64: boolean } {
  let fileType = null;
  if (content) {
    const base64FileData = content.slice(0, 4100);
    const buff = Buffer.from(base64FileData, "base64");
    fileType = getFileType(buff);
    if (fileType) {
      fileType.skipBase64 = false;
    } else {
      let shouldSkipBase64 = true;
      try {
        JSON.parse(content);
      } catch (e) {
        shouldSkipBase64 = false;
      }
      fileType = {
        ext: "json",
        mime: "text/plain",
        skipBase64: shouldSkipBase64
      };
    }
  }
  return fileType;
}

export function docTypeTranslations(docType) {
  if (docType === DocTypes.SELFIE) {
    return "SELFIE";
  }
  if (docType === DocTypes.PAN) {
    return "PAN";
  }
  if (docType === DocTypes.AADHAAR) {
    return "AADHAAR / VOTER ID";
  }
  if (docType === DocTypes.CURRENT_ADDRESS_PROOF) {
    return "CURRENT ADDRESS PROOF";
  }
  if (docType === DocTypes.PAY_SLIP_1) {
    return "LATEST PAYSLIP (Optional)";
  }
  if (docType === DocTypes.RENTAL_AGREEMENT) {
    return "RENTAL AGREEMENT";
  }
  if (docType === DocTypes.OFFER_LETTER) {
    return "OFFER LETTER";
  }
  if (docType === DocTypes.OTHER) {
    return "OTHER";
  }
  if (docType === DocTypes.CURR_ADDR_PROOF) {
    return "CURRENT ADDRESS PROOF";
  }
  if (docType === DocTypes.PAY_SLIP) {
    return "PAYSLIP";
  }
  if (docType === DocTypes.SIGNED_CHEQUE) {
    return "SIGNED CHEQUE";
  }
  if (docType === DocTypes.CANCELLED_CHEQUE) {
    return "CHEQUE";
  }
  if (docType === DocTypes.NACH) {
    return "NACH";
  }
}

function getRequiredDocsToRender(
  docs: IDocument[],
  docTypetoRender: DocTypes[]
) {
  const docToRender = [];
  for (let i = 0; i < docTypetoRender.length; i++) {
    let contain = false;
    for (let j = 0; j < docs.length; j++) {
      if (docs[j].type == docTypetoRender[i]) {
        {
          docToRender.push(docs[j]);
        }
        contain = true;
      }
    }
    if (!contain) {
      docToRender.push({
        type: docTypetoRender[i],
        date: null
      });
    }
  }
  return docToRender;
}

export function getDocumentsToRender(
  documents: IDocument[],
  docTypeRequired: DocTypes[],
  params: { id: string }
) {
  let docs = documents.filter(d => d != null);
  const presentDocTypes = docs.map(d => d.type);
  let allDocTypes = docTypeRequired ? docTypeRequired : getDocumentsToApply();
  if (params && params.id && !docTypeRequired) {
    allDocTypes = getDocUploadPortalDocTypes();
  }
  const missingDocTypes = allDocTypes.filter(
    d => presentDocTypes.indexOf(d) === -1
  );

  if (!!docTypeRequired) {
    docs = getRequiredDocsToRender(docs, allDocTypes);
  } else {
    if (docs.length === 0) {
      docs = allDocTypes.map(d => {
        return { type: d, date: null };
      });
    } else {
      missingDocTypes.map(d => {
        docs.push({
          type: d,
          date: null
        });
      });
    }
  }
  return docs;
}
export function getCampaignInfo() {
  return new Promise((resolve, reject) => {
    request(
        {
          method: "GET",
          url: `https://${envLam !== "prod" ? "uat-" : ""}shubh-loans.firebaseio.com/campaign.json`,
        }, (err, httpReq, response) => {
          resolve(response);
        });
  });
}

export function validateUtmParams(utmParams) {
  return ((utmParams.source && utmParams.source !== "") ||
      (utmParams.medium && utmParams.medium !== "") ||
      (utmParams.campaign && utmParams.medium !== ""));
}

export function sliceValueUptoMaxLength( value: string | number, maxLength: number): string {
  return String(value).length > maxLength ? String(value).slice(0, maxLength) : String(value);
}

export function addCountryCode(value: string) {
  if (!value.startsWith("+")) {
    value = `+91${value}`;
  }
  return value;
}
